const styles = theme => ({
    root: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
    },
    rootGrid: {
        flexGrow: 1,
    },
    table: {
        minWidth: 700,
        overflowX: 'auto',
    },
    tableCell: {
        padding: '4px 15px 4px 20px',
        cursor: 'default'
    },
    tableCellCenter: {
        textAlign: 'center',
        padding: '4px 15px 4px 20px',
    },
    tableIconBtn: {
        textAlign: 'center',
        padding: '5px 15px 5px 0',
    },
    headerLabels: {
        fontWeight: '700',
        fontSize: '0.9rem',
    },
    buttons: {
        padding: '15px 0 0 15px'
    },
    inputFormField: {
        marginTop: '32px',
        marginBottom: '8px',
        color: '#000',
    },
    inputFormFieldDisabled: {
        marginTop: '32px',
        marginBottom: '8px',
        color: 'rgb(114, 114, 114)',
    },
    redirectViewContent: {
        padding: '15px'
    },
    redirectContentParagraph: {
        color: '#666',
        margin: '0'
    },
    redirectViewLead: {
        fontSize: '18px'
    },
    textEditor: {
        marginTop: '30px'
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    containerLineOne: {
        display: 'flex',
        flexDirection: 'row',
    },
    containerLineTwo: {
        display: 'redirect',
        flexDirection: 'row',
    },
    textField: {
        marginLeft: 0,
        marginRight: theme.spacing.unit,
        width: 248,
    },
    menu: {
        width: 200,
    },
    selectMenuItem: {
        fontSize: '14px',
        paddingTop: 5,
        paddingBottom: 5,
    },
    selectMenuItemFilters: {
        fontSize: '14px',
        padding: '0 15px'
    },
    filterButton: {
        marginLeft: 0,
        marginTop: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 2,
    },
    redirectsEditorLabel: {
        margin: '30px 0',
    },
    redirectsEditorContent: {
        marginTop: 10,
    },
    dialogActionsBtn: {
        margin: '8px 19px'
    },
    [theme.breakpoints.up('xs')]: {
        redirectViewHeading: {
            height: '80px',
        },
        redirectViewLead: {
            margin: '0'
        },
        textField: {
            width: '100%',
            margin: 0
        },
    },
    [theme.breakpoints.up('sm')]: {
        root: {
            width: '90%',
        },
        redirectViewHeading: {
            height: '60px'
        },
        redirectViewLead: {
            margin: '18px 0'
        },
        textField: {
            width: '100%',
            margin: 0
        },
    },
    [theme.breakpoints.up('md')]: {
        root: {
            width: '95%',
        },
    },
    [theme.breakpoints.up('lg')]: {
        root: {
            width: '97%',
        },
    },
    [theme.breakpoints.up('xl')]: {
        root: {
            width: '100%',
        },
    },
    rootErrorsTable: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
        marginBottom: 20
    },
    errorsTable: {
        minWidth: 700,
        overflowX: 'auto',
    },
    errorsTitle: {
        textAlign: 'center',
        padding: '15px 0px',
    },
});

export default styles;


// WEBPACK FOOTER //
// ./src/containers/redirects/style/styles.js